import React from "react";
import { AnalysisTextArea } from "../AnalysisTextArea/AnalysisTextArea";
import { MediaUploader } from "../MediaUploader/MediaUploader";
import styles from "./Steps.module.scss";
//tr
import { useTranslation } from "react-i18next";
import { tr } from "../../../utils/translations/translator";
import { Tip } from "../interfaces/tip/Tip";
import { valueof } from "../interfaces/tip/MatchForecast";
interface StepTwoProps {
  hooks: {
    handleTipValue: (key: keyof Tip, value: valueof<Tip>) => void;
  };
  tip: Tip;
}

export const StepTwo: React.FC<StepTwoProps> = ({
  hooks: { handleTipValue },
  tip,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.StepsContent}>
      <span className={styles.header}>{tr(t, "analysis").toUpperCase()}</span>

      <span className={styles.subHeader}>{tr(t, "analysis_info")}</span>

      <AnalysisTextArea
        onChange={(markdown: string, rawContent: string) => {
          handleTipValue("analysis", markdown);
          handleTipValue("rawAnalysis", rawContent);
        }}
        rawValue={tip.rawAnalysis}
      />

      <MediaUploader
        onSelect={(files) => {
          handleTipValue("media", files);
        }}
        value={tip.media}
      />
    </div>
  );
};
